import { type FeedContentResourceTypename } from "@framework/types/wordpress";

export const FEED_CONTENT_RESOURCE_TYPES: readonly FeedContentResourceTypename[] =
  [
    "EmbedStoryResourceType",
    "LinkPostResourceType",
    "MapResourceType",
    "PackageResourceType",
    "PostResourceType",
    "StreamResourceType",
    "VaultResourceType",
    "QuickPostResourceType",
    "VideoPostResourceType",
    "CustomStoryResourceType",
    "DiningReportResourceType",
  ];
